import HBIcon from "@/components/HBIcon";
import formatTime from "@/utils/formatTime";
import dayjs from "dayjs";
import { useContext, useMemo } from "react";
import { VipDialogContext } from "../shared/configContext";
import { parseSkuDuration } from "../shared/utils";
import CancelSubscribeConfirm from "../subscribeMng/confirm";
import styles from "./index.module.less";

export default function SubscribeMngTab({ onMore, onUnSubscribe, onCancel }) {
  const { rightData } = useContext(VipDialogContext);

  const vip_expire = rightData.vip_expire;
  const subscription = rightData.subscription[0];

  const monthPrice = useMemo(() => {
    const duration = parseSkuDuration(subscription.items[0].content);
    return (
      subscription.items[0].content.price /
      dayjs.duration(duration.num, duration.unit).asMonths(true)
    ).toFixed(2);
  }, [subscription]);

  return (
    <div
      className={styles.subscribeTab}
      data-dialog-title="自动续费管理弹窗"
      data-gd-expose="dialog_expose"
    >
      <div className={styles.subscribe}>
        <div className={styles.header}>
          <span>
            你当前是{subscription.items[0].content.name}，每月仅需{monthPrice}元
          </span>
          <div
            className={styles.cancel}
            onClick={() => {
              onCancel && onCancel();
              CancelSubscribeConfirm.open({
                subscription,
                vip_expire,
                onUnSubscribe,
              });
            }}
          >
            取消自动续费
          </div>
        </div>
        <div className={styles.info}>
          <div>
            <div className={styles.label}>自动续费产品</div>
            <div>{subscription.items[0].content.name}</div>
          </div>
          <div>
            <div className={styles.label}>下次续费时间</div>
            <div>预计{formatTime(subscription.end_time, "YYYY/MM/DD")}</div>
          </div>
          <div>
            <div className={styles.label}>续费金额</div>
            <div>{subscription.items[0].content.price}</div>
          </div>
          <div>
            <div className={styles.label}>支付方式</div>
            <div>
              {subscription.extended?.gateway_creation?.channel === "wx_pub"
                ? "微信"
                : "支付宝"}
            </div>
          </div>
        </div>
      </div>

      <div className={styles.adBlock}>
        <div className={styles.content}>
          <div>个人VIP包年，每月仅需8.25元</div>
          <div>包月、包季、包年满足你的不同需求</div>
        </div>
        <a className={styles.moreBtn} onClick={onMore}>
          查看更多方案 <HBIcon type="ic_chevron_right" />
        </a>
      </div>
    </div>
  );
}
